import React, { useEffect, useState } from 'react';
import { withSnackbar } from 'notistack';

import './style.scss';
import { ScreenTitle } from '../../../../components';
import { Strings } from '../../../../shared/constants/Constants';
import * as achievementDetails from '../../../../shared/constants/AchievementConstants';
import LoadingModal from '../../../../components/atoms/LoadingModal';

const Achievements = ({
  fetchAchievementDetails,
  userId,
  sessionToken,
  loading,
  AchievementData,
  unlockedAchievementArray,
  enqueueSnackbar,
}) => {
  const [all_achievements, setAll_achievements] = useState({
    flash_start: achievementDetails.achievementDetails_1,
    flash_end: achievementDetails.achievementDetails_2,
    mcq_start: achievementDetails.achievementDetails_3,
    mcq_one_correct: achievementDetails.achievementDetails_4,
    mcq_end: achievementDetails.achievementDetails_5,
    simulated_one: achievementDetails.achievementDetails_6,
    simulated_two: achievementDetails.achievementDetails_7,
  });

  // const [user_achievements, setUser_achievements] = useState([]);

  useEffect(() => {
    fetchAchievementDetails(
      {
        userId,
        sessionToken,
      },
      (message, type) => {
        if (type !== 'success') {
          enqueueSnackbar(message, {
            variant: type,
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
          });
        }
      },
    );
  }, [fetchAchievementDetails, sessionToken, userId]);

  // useEffect(() => {
  //   setUser_achievements(AchievementData);
  // }, [AchievementData]);

  useEffect(() => {
    Object.keys(all_achievements).forEach((key, index) => {
      if (AchievementData) {
        AchievementData.forEach((data) => {
          if (data.achievement_type === key) {
            return (all_achievements[key].status = '1');
          }
        });
      }

      /* update achievement through reducer */
      if (unlockedAchievementArray[index]) {
        all_achievements[key].status = '1';
      }
    });
  }, [AchievementData, all_achievements, unlockedAchievementArray]);

  return (
    <>
      <ScreenTitle title={Strings.dashboard} subTitle={Strings.achievements}/>
      {loading ? (
        <LoadingModal isVisible={loading}/>
      ) : (
        <div className='achievement-container'>
          {Object.keys(all_achievements).map((data, index) => (
            <div
              className='achievement'
              style={{
                opacity: parseInt(all_achievements[data].status) ? 1 : 0.5,
              }}
              key={index}
            >
              <div>
                <div
                  className='image-container'
                  style={{
                    backgroundColor: parseInt(all_achievements[data].status)
                      ? '#1b3664'
                      : 'gray',
                  }}
                >
                  <img
                    src={require('../../../../Assets/Images/Icons/achievements_shape.png')}
                    alt='trophy'
                  />
                </div>
              </div>
              <div className='text-container'>
                <h6>{all_achievements[data].achievement_title}</h6>
                <p>{all_achievements[data].achievement_detail}</p>
              </div>
            </div>
          ))}

          {/*<div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>All Flashcards</h6>
            <p>You have viewed all FLASHCARDS.</p>
          </div>
        </div>
        <div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>First Question</h6>
            <p>You have answered your first question.</p>
          </div>
        </div>
        <div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>First Correct Question</h6>
            <p>You have answered your first question correctly.</p>
          </div>
        </div>
        <div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>All Questions</h6>
            <p>You have answered all the questions.</p>
          </div>
        </div>
        <div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>First Simulated Test</h6>
            <p>You have completed your first simulated exam.</p>
          </div>
        </div>
        <div className="achievement">
          <div>
            <div className="image-container">
              <img
                src={require("../../../../Assets/Images/Icons/achievements_shape.png")}
                alt="trophy"
              />
            </div>
          </div>
          <div className="text-container">
            <h6>Second Simulated Test</h6>
            <p>You have completed your second simulated exam.</p>
          </div>
      </div>*/}
        </div>
      )}
    </>
  );
};

export default withSnackbar(Achievements);
